import { render, staticRenderFns } from "./ico-landing.vue?vue&type=template&id=17405e0d&"
import script from "./ico-landing.vue?vue&type=script&lang=js&"
export * from "./ico-landing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports